// const apiUrlOne = "http://localhost:8000/api/v1";


// const apiUrlOne = "http://localhost:3101/api/v1";
// const apiUrlOne = "https://api.test.healatindia.com/api/v1";
// const apiUrlOne = "https://api.staging.healatindia.com/api/v1";
const apiUrlOne = "https://api.healatindia.com/api/v1";

// const apiUrlOne = "http://192.168.0.102:3101/api/v1";

// const apiUrlOne = process.env.REACT_APP_API_URL || "https://api.test.healatindia.com/api/v1";

export default apiUrlOne;
